<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Customer Voice table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <div class="col-sm-4">
            <select name="pagesx" id="pagesx" v-model="pages" @change="changepages" class="form-select form-select-sm">
              <option value="all">All</option>
              <option value="home">Home</option>
              <option value="bom">BOM</option>
              <option value="advisory">Advisory</option>
            </select>
          </div>

          <div class="col-sm-4">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari"
                name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari"
                @click="cari"><i class="fas fa-search"></i></button>
            </div>
          </div>
          <div class="col-sm-4">
            <!-- Button to open the modal -->
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add Customer Voice
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Name
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Work
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Topic
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Reaction
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <img :src="item.photo" class="avatar avatar-sm me-3" alt="user1" />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.name }}</h6>
                  </div>
                </div>
              </td>
              <td>{{ item.work }}</td>
              <td>{{ item.topic }}</td>
              <td>{{ item.reaction }}</td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)"><i
                    class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i
                    class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">Add New Customer Voice</h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit Customer Voice</h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3">
                  <label for="name" class="form-label">Name</label>
                  <input type="text" class="form-control" v-model="formData.name" id="name" required>
                </div>
                <div class="mb-3">
                  <label for="work" class="form-label">Work</label>
                  <input type="text" class="form-control" v-model="formData.work" id="work" required>
                </div>
                <div class="mb-3">
                  <label for="topic" class="form-label">Topic</label>
                  <input type="text" class="form-control" v-model="formData.topic" id="topic" required>
                </div>
                <div class="mb-3">
                  <label for="reaction" class="form-label">Reaction</label>
                  <input type="text" class="form-control" v-model="formData.reaction" id="reaction" required>
                </div>
                <div class="mb-3">
                  <label for="file" class="form-label">Foto</label>
                  <input type="file" class="form-control" @change="handleFileUpload" :required="method == 'add'"
                    accept="image/*">
                  <div v-if="logoPreview" class="m-4">
                    <img :src="logoPreview" alt="" srcset="" style="max-height: 100px" />
                  </div>
                </div>
                <div class="mb-3">
                  <select name="pages" id="pages" v-model="formData.pages" class="form-select form-select-sm" required>
                    <option value="all">All</option>
                    <option value="home">Home</option>
                    <option value="bom">BOM</option>
                    <option value="advisory">Advisory</option>
                  </select>
                </div>

                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">Close</button>
                  <button type="submit" class="btn btn-primary btn-sm">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  data() {
    return {
      customerVList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage: 10,
      sortOrder: 'desc',
      searchQuery: '',
      showModal: false, // Controls modal visibility
      formData: {
        name: '',
        file: null,
        work: '',
        topic: '',
        reaction: '',
        pages: 'all'
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      pages: 'all',
      logoPreview: null
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchcustomerVList();
  },
  computed: {
    totalItems() {
      return this.customerVList.length;
    },
    paginatedData() {
      return this.customerVList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchcustomerVList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/customer_voice",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
          pages: this.pages
        },
        headers: {
          'Authorization': 'Bearer ' + access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {
          if (response.data?.message == 'success') {
            this.customerVList = response.data.data.customer_voice_list; // Assign banner_list to local data
            this.totalPages = response.data.data.paginate // Update the total number of pages (this depends on how the API returns pagination info)
          } else {
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchcustomerVList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchcustomerVList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchcustomerVList();
    },
    updateItemsPerPage() {
      this.fetchcustomerVList();
    },
    updatesoftby() {
      this.fetchcustomerVList();
    },
    cari() {
      this.fetchcustomerVList();
    },
    changepages() {
      this.fetchcustomerVList();
    },
    closeModal() {
      this.showModal = false;
      // Reset form data
      this.formData = {
        name: '',
        file: null,
        work: '',
        topic: '',
        reaction: '',
      };
      this.method = 'add';
      this.logoPreview = null;
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + '...';
      }
      return text;
    },
    handleFileUpload(event) {
      this.formData.file = event.target.files[0]; // Capture the file
      this.logoPreview = URL.createObjectURL(event.target.files[0]);
    },
    async submitForm() {
      let access_token = localStorage.getItem('access_token');
      const data = new FormData();
      var config = {}
      if (this.method == 'add') {
        data.append('name', this.formData.name);
        data.append('work', this.formData.work);
        data.append('topic', this.formData.topic);
        data.append('reaction', this.formData.reaction);
        data.append('photo', this.formData.file);
        data.append('pages', this.formData.pages);

        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/customer_voice',
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        };
      } else {
        data.append('name', this.formData.name);
        data.append('work', this.formData.work);
        data.append('topic', this.formData.topic);
        data.append('reaction', this.formData.reaction);
        data.append('photo', this.formData.file);
        data.append('pages', this.formData.pages);

        config = {
          method: 'put',
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/customer_voice/' + this.formData.id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          },
          data: data,
        }
      }

      try {
        const response = await axios.request(config);
        if (response.data?.message == 'success') {
          this.fetchcustomerVList();
          if (this.method == 'add') {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success"
            });
          }
          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = 'danger';
          this.alerttext = 'Error add data'
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.message
        this.alertstatus = 'danger';
        this.alerttext = err
        console.error("Error fetching data:", error);
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/customer_voice/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchcustomerVList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },

    edit(item) {
      this.formData = {
        name: item.name,
        file: null,
        work: item.work,
        topic: item.topic,
        reaction: item.reaction,
        id: item.id,
        pages: item.pages
      };
      this.logoPreview = item.photo;

      this.showModal = true;
      this.method = 'edit';
    }

  },
};
</script>
<style>
/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}
</style>